import { render, staticRenderFns } from "./_Config.vue?vue&type=template&id=60ac3f7a"
import script from "./_Config.vue?vue&type=script&lang=ts"
export * from "./_Config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports